const {
    GET_CLIENT,
    ERROR_CLIENT,
    INSTANCE_RUNNING_STATUS
} = require('../Constants/client.constants');

const initalState = {
    error: {
        code: '',
        message: ''
    },
    clientInfo: {},
    instanceRunningStatus: []
};

export default (state = initalState, action) => {
    switch (action.type) {
        case GET_CLIENT:
            return {
                ...state,
                clientInfo: action.data
            };
        case INSTANCE_RUNNING_STATUS:
            return {
                ...state,
                instanceRunningStatus: action.data
            };
        case ERROR_CLIENT:
            return {
                ...state,
                error: {
                    message: action.data,
                    code: action.code
                }
            };
        default:
            return state;
    }
};
